(function () {
    var modal = document.getElementById('interstitial-ad');
    if (!modal) return;

    // Video from the page tagged #interstitial (see the partial): copy the
    // first <video> src out of the inert <template>, then drop whichever
    // media element ends up unused so the image fallback only shows when
    // there's no page video.
    var pageVideo = modal.querySelector('[data-interstitial-page-video]');
    if (pageVideo) {
        var source = modal.querySelector('.interstitial-ad-source');
        var found = source && source.content.querySelector('video[src], video source[src]');
        var image = modal.querySelector('img.interstitial-ad-media');
        if (found) {
            pageVideo.src = found.getAttribute('src');
            if (image) image.parentNode.removeChild(image);
        } else {
            pageVideo.parentNode.removeChild(pageVideo);
        }
    }
    if (!modal.querySelector('.interstitial-ad-media')) return;

    var STORAGE_KEY = 'aleph-interstitial-dismissed';
    var alreadyDismissed = false;
    try {
        alreadyDismissed = !!sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {}
    if (alreadyDismissed) return;

    function close() {
        modal.hidden = true;
        document.body.classList.remove('interstitial-open');
        var video = modal.querySelector('video');
        if (video) video.pause();
        try {
            sessionStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {}
    }

    var closers = modal.querySelectorAll('[data-interstitial-close]');
    for (var i = 0; i < closers.length; i++) {
        closers[i].addEventListener('click', close);
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
    });

    function reveal() {
        modal.hidden = false;
        document.body.classList.add('interstitial-open');
    }

    var video = modal.querySelector('video');
    if (!video) {
        reveal();
        return;
    }

    // Reveal only once the first frame is in, so a video that fails or
    // stalls never shows up as an empty panel with only the close button,
    // and a large file doesn't leave the box blank while it starts loading.
    // (Waiting for data rather than reacting to `error`: a stalled request
    // may never fire one.)
    // The loading happens in a detached copy: Chrome defers loading a
    // <video> under a `hidden` ancestor (measured ~8s vs ~0.3s for the same
    // local file), so the copy loads, then takes the placeholder's spot.
    // A <video> revealed from `hidden` doesn't reliably honor `autoplay`
    // either -- start it explicitly. play() returns a promise that rejects
    // if the browser blocks it; nothing useful to do about that here.
    var loader = video.cloneNode(false);
    loader.muted = true;
    loader.loop = true;
    loader.playsInline = true;
    loader.preload = 'auto';
    loader.addEventListener('loadeddata', function () {
        video.parentNode.replaceChild(loader, video);
        reveal();
        loader.play().catch(function () {});
    }, {once: true});
    loader.src = video.getAttribute('src');
})();
